import { __rest, __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { forwardRef, useState, useImperativeHandle } from 'react';
import ZigTableData from './ZigTableData.js';
import useFinitePaginatedQuery from './use/useFinitePaginatedQuery.js';

var ZigTableRtkFiniteQuery = function (_a, ref) {
    var _b;
    var useQuery = _a.useQuery, queryExtraParams = _a.queryExtraParams, queryDataMapper = _a.queryDataMapper, props = __rest(_a, ["useQuery", "queryExtraParams", "queryDataMapper"]);
    var _c = useState([]), sorting = _c[0], setSorting = _c[1];
    var _d = useFinitePaginatedQuery({
        useQuery: useQuery,
        sorting: sorting,
        queryExtraParams: queryExtraParams,
    }), pagination = _d.pagination, setPagination = _d.setPagination, isFetching = _d.isFetching, isLoading = _d.isLoading, totalPages = _d.totalPages, data = _d.data, refetch = _d.refetch;
    useImperativeHandle(ref, function () { return ({
        refetch: refetch,
    }); });
    var items = (queryDataMapper ? (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.map(queryDataMapper) : data === null || data === void 0 ? void 0 : data.data) || [];
    return (React__default.createElement(ZigTableData, __assign({}, props, { state: __assign(__assign({}, (props.state || {})), { sorting: sorting }), sorting: sorting, manualPagination: true, data: items, onSortingChange: setSorting, pageCount: totalPages, loading: isLoading, fetching: isFetching, pagination: pagination, onPaginationChange: setPagination })));
};
var ZigTableRtkFiniteQuery$1 = forwardRef(ZigTableRtkFiniteQuery);

export { ZigTableRtkFiniteQuery$1 as default };
